"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryTargetComponent = exports.BoundaryTargetDesign = exports.BoundaryTargetTypeSchema = exports.BoundaryTargetType = exports.BoundaryTargetSchema = exports.TraversalInTargetSchema = exports.TraversalOutTargetSchema = exports.DesignTargetSchema = exports.ComponentTargetSchema = exports.BoundaryTargetTraversalRootSchema = void 0;
exports.isBoundaryTargetRelativeSignals = isBoundaryTargetRelativeSignals;
exports.isBoundaryTargetTraversalIn = isBoundaryTargetTraversalIn;
exports.isBoundaryTargetTraversalRoot = isBoundaryTargetTraversalRoot;
exports.getBoundaryTargetRelativeSignals = getBoundaryTargetRelativeSignals;
exports.boundaryTargetToString = boundaryTargetToString;
exports.isBoundaryTargetRelativeWithSignal = isBoundaryTargetRelativeWithSignal;
exports.isSignalInRelativeSignal = isSignalInRelativeSignal;
exports.getBoundaryTargetSignals = getBoundaryTargetSignals;
exports.getBoundaryTargetSignalIds = getBoundaryTargetSignalIds;
const zod_1 = require("zod");
const RelativeSignal_1 = require("./RelativeSignal");
const Utils_1 = require("./Utils");
exports.BoundaryTargetTraversalRootSchema = zod_1.z.object({
    traversalRoot: zod_1.z.literal(true),
    signal: zod_1.z.string().optional(),
    functionSignalRef: zod_1.z
        .object({
        signal: zod_1.z.string(),
        function: zod_1.z.string(),
    })
        .optional(),
});
exports.ComponentTargetSchema = zod_1.z.object({
    component: zod_1.z.literal(true),
});
exports.DesignTargetSchema = zod_1.z.object({
    design: zod_1.z.literal(true),
});
exports.TraversalOutTargetSchema = zod_1.z.object({
    traversalOut: zod_1.z.literal(true),
});
exports.TraversalInTargetSchema = zod_1.z.object({
    traversalIn: zod_1.z.literal(true),
});
exports.BoundaryTargetSchema = zod_1.z.union([
    RelativeSignal_1.RelativeSignalSchema,
    exports.ComponentTargetSchema,
    exports.DesignTargetSchema,
    exports.TraversalOutTargetSchema,
    exports.TraversalInTargetSchema,
    exports.BoundaryTargetTraversalRootSchema,
]);
var BoundaryTargetType;
(function (BoundaryTargetType) {
    BoundaryTargetType["RelativeSignal"] = "RelativeSignal";
    BoundaryTargetType["Component"] = "Component";
    BoundaryTargetType["Design"] = "Design";
    BoundaryTargetType["TraversalIn"] = "TraversalIn";
    BoundaryTargetType["TraversalRoot"] = "TraversalRoot";
})(BoundaryTargetType || (exports.BoundaryTargetType = BoundaryTargetType = {}));
exports.BoundaryTargetTypeSchema = zod_1.z.nativeEnum(BoundaryTargetType);
exports.BoundaryTargetDesign = { design: true };
exports.BoundaryTargetComponent = { component: true };
function isBoundaryTargetRelativeSignals(target) {
    return target?.signal_name !== undefined || target?.signal !== undefined;
}
function isBoundaryTargetTraversalIn(target) {
    return target?.traversalIn === true;
}
function isBoundaryTargetTraversalRoot(target) {
    return target?.traversalRoot === true;
}
function getBoundaryTargetRelativeSignals(target) {
    if (isBoundaryTargetRelativeSignals(target)) {
        return [
            ...(0, Utils_1.toArray)(target.signal).map((s) => ({ signal: s })),
            ...(0, Utils_1.toArray)(target.signal_name).map((s) => ({ signal_name: s })),
        ];
    }
    return [];
}
function boundaryTargetToString(target) {
    if (isBoundaryTargetRelativeSignals(target)) {
        return `RelativeSignal(${[...(0, Utils_1.toArray)(target.signal), ...(0, Utils_1.toArray)(target.signal_name)].join(', ')})`;
    }
    if (target === exports.BoundaryTargetDesign) {
        return 'Design';
    }
    if (target === exports.BoundaryTargetComponent) {
        return 'Component';
    }
    if (isBoundaryTargetTraversalIn(target)) {
        return 'TraversalIn';
    }
    if (isBoundaryTargetTraversalRoot(target)) {
        return 'TraversalRoot';
    }
    return 'Unknown';
}
function isBoundaryTargetRelativeWithSignal(target, signal) {
    return !!target && isSignalInRelativeSignal(target, signal);
}
function isSignalInRelativeSignal(target, signal) {
    if (target.signal !== undefined) {
        return (Array.isArray(target.signal) && target.signal.indexOf(signal.id) !== -1) || target.signal === signal.id;
    }
    return (target.signal_name !== undefined &&
        ((Array.isArray(target.signal_name) && target.signal_name.indexOf(signal.name) !== -1) ||
            target.signal_name === signal.name));
}
function getBoundaryTargetSignals(signals, target) {
    if (target && isBoundaryTargetRelativeSignals(target)) {
        return Array.from(new Set([
            ...(0, Utils_1.toArray)(target.signal).map((id) => signals.find((signal) => signal.id === id)),
            ...(0, Utils_1.toArray)(target.signal_name).map((s) => signals.find((signal) => signal.name === s)),
        ])).filter((x) => x !== undefined);
    }
    return [];
}
function getBoundaryTargetSignalIds(signals, target) {
    if (target && isBoundaryTargetRelativeSignals(target)) {
        return Array.from(new Set([
            ...(0, Utils_1.toArray)(target.signal),
            ...(0, Utils_1.toArray)(target.signal_name)
                .map((s) => signals.find((signal) => signal.name === s)?.id)
                .filter(Boolean),
        ]));
    }
    return [];
}
//# sourceMappingURL=BoundaryTarget.js.map